<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="content-left-top-cornor">
  <p-tabView>
    
    <p-tabPanel headerStyleClass="selected" header="search">
      <app-search #search></app-search>
    </p-tabPanel>
  </p-tabView>
</div>